import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { EventMenuProfileService } from 'src/app/components/profile-menu/profile-menu.service';
import { ApiCore } from 'src/app/config/api';
import { AppRoutes } from 'src/app/config/routes';
import { ApiService } from 'src/app/core/http/api.service';
import { MenuService } from 'src/app/layouts/main-layout/services/app.menu.service';
import { DeviceDetectorService } from 'src/app/shared/services/device-detector.service';

@Component({
  selector: 'app-modal-cajero',
  templateUrl: './modal-cajero.component.html',
  styleUrls: ['./modal-cajero.component.css']
})
export class ModalCajeroComponent implements OnInit {
  @Input() mobile = false;
  @Input() show: boolean = false;
  @Output() toggle = new EventEmitter<boolean>();
  public loadingTransactions: boolean = false;
  public transactions: {
    creditsAmount: number;
    createdAt: string;
    id: string;
    type: string;
  }[] = [];
  // this.getBonuses();
  public isMobile: boolean = false;
  
  constructor(
    private readonly api: ApiService,
    private readonly deviceDetector: DeviceDetectorService,
    private readonly router: Router,
    private readonly eventMenuProfileService: EventMenuProfileService,
  ) {
    this.deviceDetector.isMobile().subscribe((isMobile) => {
      this.isMobile = isMobile;
    });
  }

  ngOnInit(): void {
    this.getTransactions();
  }

  private getTransactions() {
    this.api.list(ApiCore.OPERATOR + '/last-transactions').subscribe({
      next: (res) => {
        console.log({ Transactions: res });
        this.transactions = res.data;
        this.loadingTransactions = false;
      },
      error: (err) => {
        console.error({ err });
      },
    });
  }
  redirectToTransactions(){
    this.eventMenuProfileService.showProfile()
    this.toggle.emit()
    this.router.navigate([AppRoutes.USER_PROFILE], {
      queryParams: {
        transactions: 'active'
      }
    });
    
  }
}
